import { Minus, Plus } from "lucide-react";
import { ShieldPreview } from "../shield/ShieldPreview";
import { SIZES, sizeOf, eur, shieldMm } from "../../lib/shield";
import { SeeOnWall } from "../WallPreview";

export const OrderLine = ({ line, onChange, onRemove }) => {
  const { draft, size, quantity } = line;
  const id = draft.id;
  const setQty = (q) => onChange({ quantity: Math.max(0, Math.min(100, q)) });
  return (
    <div className={`flex gap-4 border-2 bg-white p-3 ${quantity ? "border-slate-200" : "border-dashed border-slate-200 opacity-60"}`} data-testid={`order-line-${id}`}>
      <div className="w-20 shrink-0"><ShieldPreview design={{ ...draft.design, guide: false }} testId={`order-shield-${id}`} /></div>
      <div className="min-w-0 flex-1 space-y-2">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0 truncate font-display text-lg font-extrabold uppercase">{draft.title}</div>
          <div className="font-cond shrink-0 text-xl font-bold" data-testid={`order-line-total-${id}`}>{eur(sizeOf(size).price * quantity)}</div>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <select value={size} onChange={(e) => onChange({ size: e.target.value })} data-testid={`order-size-${id}`}
            className="w-full min-w-0 max-w-full border-2 border-slate-200 px-2 py-1.5 text-sm font-semibold outline-none focus:border-slate-900 sm:w-auto">
            {SIZES.map((s) => <option key={s.id} value={s.id}>{s.name} · shield {shieldMm(s).w}×{s.h} mm · {eur(s.price)}{s.recommended ? " (Recommended)" : ""}</option>)}
          </select>
          <div className="flex items-center border-2 border-slate-200">
            <button type="button" onClick={() => setQty(quantity - 1)} className="p-2 hover:bg-slate-100" aria-label="Decrease" data-testid={`order-qty-dec-${id}`}><Minus className="h-3.5 w-3.5" /></button>
            <input value={quantity} inputMode="numeric" onChange={(e) => /^\d*$/.test(e.target.value) && setQty(Number(e.target.value || 0))}
              className="w-10 text-center text-sm font-bold outline-none" aria-label="Quantity" data-testid={`order-qty-${id}`} />
            <button type="button" onClick={() => setQty(quantity + 1)} className="p-2 hover:bg-slate-100" aria-label="Increase" data-testid={`order-qty-inc-${id}`}><Plus className="h-3.5 w-3.5" /></button>
          </div>
          <SeeOnWall design={draft.design} size={size} testId={`order-see-on-wall-${id}`} />
          {quantity === 0 && <span className="text-xs text-slate-500">Not included</span>}
          {onRemove && <button type="button" onClick={onRemove} className="text-xs font-bold text-red-600 underline" data-testid={`order-remove-${id}`}>Remove</button>}
        </div>
      </div>
    </div>
  );
};
